import type { ReactNode } from 'react';
import { createContext } from 'react';

import type { BreadcrumbItem } from '@/_navigation';

export type THeaderObj = {
  heading?: string;
  description?: string;
  callback?: () => void;
  allowBack?: boolean;
  breadCrumbs?: BreadcrumbItem[];
  preload?: boolean;
  rightSlot?: ReactNode;
  subContainer?: boolean;
};

const header: THeaderObj = {};

type THeader = {
  setHeader: (e: THeaderObj) => void;
  header: THeaderObj;
};

const defaultValue: THeader = {
  setHeader: (_e: THeaderObj) => {},
  header,
};

export const PageContext = createContext<THeader>(defaultValue);
